import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import api from '@/utils/connector/ApiConnector';
import { useUser } from "@/utils/userContext/UserContext";
import { noAuthApi } from '@/utils/connector/ApiConnector';

export function ForgotPasswordModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [emailValue, setEmailValue] = useState(localStorage.getItem("email") || "");
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState<string | null>(null);
  const userContext = useUser();
  const userData = userContext?.userData;
  const token = userData?.auth;
  const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

  const handleSubmit = async (e?: React.FormEvent) => {
    e?.preventDefault();
    setLoading(true);
    setStatusMsg(null);
    try {

      await api.post('/user/forgot-password', { email: emailValue }, );
      setStatusMsg('Se o e-mail existir, você receberá instruções para redefinir a senha.');
    } catch (err: any) {
      console.error('Erro forgot-password:', err);
      const server = err?.response?.data?.message ?? 'Erro ao solicitar recuperação de senha';
      setStatusMsg(server);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="forgot-title">
      <DialogTitle id="forgot-title">Recuperar senha</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Informe seu e-mail. Se ele existir em nosso sistema, você receberá instruções por e-mail.
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label="E-mail"
            type="email"
            fullWidth
            variant="standard"
            value={emailValue}
            onChange={(e) => setEmailValue(e.target.value)}
            required
          />
          {statusMsg && <Typography variant="body2" sx={{ mt: 2 }}>{statusMsg}</Typography>}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={loading}>Fechar</Button>
          <Button type="submit" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar instruções'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
